import { getDriverLanguage, normalizeDriverLanguage } from './driverI18n';

const zhCn = {
  loading: '正在打开车队账号…',
  application: '车队申请',
  logout: '退出',
  fleetAccount: '车队账号',
  pendingReview: '等待总部审核',
  pendingHint: '审核前可补充车队资料。通过后，车队主会进入和司机账号相同的司机端，并在“我”里管理车队。',
  saveFailed: '资料保存失败',
  fleetName: '车队名称',
  manager: '负责人',
  email: '邮箱',
  address: '地址',
  businessRegistration: '公司营业登记证明（登記簿謄本）',
  transportPermit: '运输许可',
  saveApplication: '保存申请资料',
  applicationSaved: '申请资料已保存。',
  backToDriver: '返回司机入口',
  fleetLogin: '车队登录',
  fleetLoginHint: '登录后直接使用完整司机端；车队功能会显示在“我”里。',
  phone: '手机号',
  password: '密码',
  signingIn: '登录中…',
  enterDriver: '进入司机端',
  loginFailed: '登录失败，请重试。',
  management: '车队管理',
  syncing: '同步中',
  refresh: '刷新',
  managementHint: '在这里管理车队司机与车辆；订单派单仍在“我的订单”完成。',
  addDriver: '添加司机',
  fleetDrivers: '车队司机',
  fleetVehicles: '车队车辆',
  loadingData: '正在同步车队资料…',
  loadFailed: '无法加载车队资料',
  driverUpdated: '司机资料已更新',
  driverCreated: '司机已创建',
  driverSaveFailed: '保存司机资料失败',
  vehicleSaved: '车辆已保存',
  vehicleSaveFailed: '保存车辆信息失败',
  deleteVehicleConfirm: (plate) => `删除车辆 ${plate || ''}？历史订单会保留该车当时的信息。`,
  vehicleDeleted: '车辆已删除',
  vehicleDeleteFailed: '删除车辆失败',
  passwordReset: '密码已重置',
  passwordResetFailed: '密码重置失败',
  driverDisabled: '司机已停用',
  driverRemoved: '司机已移出车队',
  operationFailed: '操作失败',
  settingSaved: '设置已保存',
  settingSaveFailed: '设置保存失败',
  exitApproved: '已允许退出',
  exitApprovalFailed: '无法处理退出申请',
  exitRequests: '退出申请',
  exitRequestsHint: '审核通过后，司机可加入其他车队。',
  driver: '司机',
  pending: '待审核',
  allowExit: '允许退出',
  editDriver: '编辑司机',
  cancel: '取消',
  driverName: '司机姓名',
  initialPassword: '初始密码（至少6位）',
  saving: '保存中…',
  saveChanges: '保存修改',
  createDriver: '创建司机账号',
  fleetOwner: '车队主',
  available: '可接单',
  dispatchable: '可派单',
  expired: '证件过期',
  disabled: '已停用',
  editProfile: '编辑资料',
  resetPassword: '重置密码',
  disableAccount: '停用账号',
  removeFromFleet: '移出车队',
  addVehicle: '添加车辆',
  vehicleHint: '车辆独立保存，指派订单时再选择司机和车辆。',
  vehicleType: '车型',
  plateNumber: '车牌号',
  platePlaceholder: '例如：品川 300 あ 12-34',
  saveVehicle: '保存车辆',
  noVehicleType: '未填写车型',
  noPlate: '未填写车牌',
  delete: '删除',
  noVehicles: '暂无已保存车辆',
  noNotifications: '暂无车队通知',
  notification: '车队通知',
  permanentFleetCode: '永久车队码',
  fleetCodeHint: '车队新增且启用的司机可立即接收本车队派单；停用或证件过期时会自动停止派单。',
  showPrice: '在司机端显示派单价格',
  showPriceHint: '开启后，车队名下司机可在订单里看到车队结算价。',
  reviewDocuments: '车队审核资料',
  reviewDocumentsHint: '营业登记证明和运输许可已由总部保存审核。',
  driversTab: '司机',
  vehiclesTab: '车辆',
  notificationsTab: '通知',
  settingsTab: '设置',
  sectionsLabel: '车队管理分区',
  passwordResetLabel: '重置司机密码',
  newPassword: '新密码（至少6位）',
  resetHint: '司机下次登录时需要更改此密码。',
  confirmReset: '确认重置',
  allowExitTitle: (name) => `允许 ${name || '该司机'} 退出？`,
  allowExitHint: '确认后，该司机会解除当前车队归属，并可以加入其他车队。未完成订单会先阻止此操作。',
  confirmAction: '确认操作',
  removeTitle: (name) => `移出 ${name}`,
  disableTitle: (name) => `停用 ${name}`,
  removeHint: '该司机必须没有未完成订单，移出后可加入其他车队。',
  disableHint: '系统会先检查该司机是否有未完成订单。',
  confirmRemove: '确认移出',
  confirmDisable: '确认停用',
};

const en = {
  ...zhCn,
  loading: 'Opening fleet account…',
  application: 'Fleet Application',
  logout: 'Sign Out',
  fleetAccount: 'Fleet Account',
  pendingReview: 'Pending Head Office Review',
  pendingHint: 'You can update the fleet application before approval. After approval, the fleet owner uses the full driver app and manages the fleet from My Page.',
  saveFailed: 'Unable to save the application.',
  fleetName: 'Fleet Name',
  manager: 'Manager',
  email: 'Email',
  address: 'Address',
  businessRegistration: 'Company Registration Certificate',
  transportPermit: 'Transport Permit',
  saveApplication: 'Save Application',
  applicationSaved: 'Application details saved.',
  backToDriver: 'Back to Driver Access',
  fleetLogin: 'Fleet Login',
  fleetLoginHint: 'Sign in to use the full driver app. Fleet tools appear in My Page.',
  phone: 'Mobile Number',
  password: 'Password',
  signingIn: 'Signing In…',
  enterDriver: 'Enter Driver App',
  loginFailed: 'Unable to sign in. Please try again.',
  management: 'Fleet Management',
  syncing: 'Syncing',
  refresh: 'Refresh',
  managementHint: 'Manage fleet drivers and vehicles here. Assign orders from My Orders.',
  addDriver: 'Add Driver',
  fleetDrivers: 'Fleet Drivers',
  fleetVehicles: 'Fleet Vehicles',
  loadingData: 'Syncing fleet information…',
  loadFailed: 'Unable to load fleet information.',
  driverUpdated: 'Driver information updated.',
  driverCreated: 'Driver account created.',
  driverSaveFailed: 'Unable to save driver information.',
  vehicleSaved: 'Vehicle saved.',
  vehicleSaveFailed: 'Unable to save vehicle information.',
  deleteVehicleConfirm: (plate) => `Delete vehicle ${plate || ''}? Historical orders will keep the original vehicle details.`,
  vehicleDeleted: 'Vehicle deleted.',
  vehicleDeleteFailed: 'Unable to delete the vehicle.',
  passwordReset: 'Password reset.',
  passwordResetFailed: 'Unable to reset the password.',
  driverDisabled: 'Driver account disabled.',
  driverRemoved: 'Driver removed from the fleet.',
  operationFailed: 'Unable to complete the action.',
  settingSaved: 'Setting saved.',
  settingSaveFailed: 'Unable to save the setting.',
  exitApproved: 'Fleet exit approved.',
  exitApprovalFailed: 'Unable to process the exit request.',
  exitRequests: 'Exit Requests',
  exitRequestsHint: 'After approval, the driver can join another fleet.',
  driver: 'Driver',
  pending: 'Pending',
  allowExit: 'Approve Exit',
  editDriver: 'Edit Driver',
  cancel: 'Cancel',
  driverName: 'Driver Name',
  initialPassword: 'Initial Password (at least 6 characters)',
  saving: 'Saving…',
  saveChanges: 'Save Changes',
  createDriver: 'Create Driver Account',
  fleetOwner: 'Fleet Owner',
  available: 'Available',
  dispatchable: 'Dispatchable',
  expired: 'Documents Expired',
  disabled: 'Disabled',
  editProfile: 'Edit Profile',
  resetPassword: 'Reset Password',
  disableAccount: 'Disable Account',
  removeFromFleet: 'Remove from Fleet',
  addVehicle: 'Add Vehicle',
  vehicleHint: 'Vehicles are saved separately and selected after choosing a driver for an order.',
  vehicleType: 'Vehicle Type',
  plateNumber: 'License Plate',
  platePlaceholder: 'Example: Shinagawa 300 A 12-34',
  saveVehicle: 'Save Vehicle',
  noVehicleType: 'Vehicle type not entered',
  noPlate: 'License plate not entered',
  delete: 'Delete',
  noVehicles: 'No saved vehicles',
  noNotifications: 'No fleet notifications',
  notification: 'Fleet Notification',
  permanentFleetCode: 'Permanent Fleet Code',
  fleetCodeHint: 'New and active fleet drivers can receive assignments immediately. Disabled drivers or drivers with expired documents are automatically blocked.',
  showPrice: 'Show dispatch price to drivers',
  showPriceHint: 'Fleet drivers can see the fleet settlement amount on their orders when enabled.',
  reviewDocuments: 'Fleet Review Documents',
  reviewDocumentsHint: 'The company registration and transport permit are stored for head office review.',
  driversTab: 'Drivers',
  vehiclesTab: 'Vehicles',
  notificationsTab: 'Notices',
  settingsTab: 'Settings',
  sectionsLabel: 'Fleet management sections',
  passwordResetLabel: 'Reset driver password',
  newPassword: 'New Password (at least 6 characters)',
  resetHint: 'The driver must use this password at the next sign-in.',
  confirmReset: 'Reset Password',
  allowExitTitle: (name) => `Allow ${name || 'this driver'} to leave?`,
  allowExitHint: 'The driver will leave this fleet and can join another fleet. Outstanding orders will block this action.',
  confirmAction: 'Confirm Action',
  removeTitle: (name) => `Remove ${name}`,
  disableTitle: (name) => `Disable ${name}`,
  removeHint: 'The driver must have no outstanding orders and can join another fleet after removal.',
  disableHint: 'The system will first check for outstanding orders.',
  confirmRemove: 'Remove',
  confirmDisable: 'Disable',
};

const ja = {
  ...en,
  loading: '車隊アカウントを開いています…',
  application: 'フリート申請',
  logout: 'ログアウト',
  fleetAccount: 'フリートアカウント',
  pendingReview: '本部審査待ち',
  pendingHint: '承認前はフリート申請資料を更新できます。承認後、フリート責任者は通常のドライバーアプリを利用し、「マイページ」からフリートを管理できます。',
  saveFailed: '申請資料を保存できませんでした。',
  fleetName: 'フリート名',
  manager: '責任者',
  email: 'メールアドレス',
  address: '住所',
  businessRegistration: '会社登記簿謄本',
  transportPermit: '運送許可証',
  saveApplication: '申請資料を保存',
  applicationSaved: '申請資料を保存しました。',
  backToDriver: 'ドライバー入口へ戻る',
  fleetLogin: 'フリートログイン',
  fleetLoginHint: 'ログイン後は通常のドライバーアプリを利用できます。フリート機能はマイページに表示されます。',
  phone: '携帯電話番号',
  password: 'パスワード',
  signingIn: 'ログイン中…',
  enterDriver: 'ドライバーアプリを開く',
  loginFailed: 'ログインできませんでした。もう一度お試しください。',
  management: 'フリート管理',
  syncing: '同期中',
  refresh: '更新',
  managementHint: 'フリートのドライバーと車両を管理します。予約の配車は「予約一覧」で行います。',
  addDriver: 'ドライバー追加',
  fleetDrivers: 'フリートドライバー',
  fleetVehicles: 'フリート車両',
  loadingData: 'フリート情報を同期しています…',
  loadFailed: 'フリート情報を読み込めませんでした。',
  driverUpdated: 'ドライバー情報を更新しました。',
  driverCreated: 'ドライバーアカウントを作成しました。',
  driverSaveFailed: 'ドライバー情報を保存できませんでした。',
  vehicleSaved: '車両を保存しました。',
  vehicleSaveFailed: '車両情報を保存できませんでした。',
  deleteVehicleConfirm: (plate) => `車両 ${plate || ''} を削除しますか？過去の予約には当時の車両情報が残ります。`,
  vehicleDeleted: '車両を削除しました。',
  vehicleDeleteFailed: '車両を削除できませんでした。',
  passwordReset: 'パスワードを再設定しました。',
  passwordResetFailed: 'パスワードを再設定できませんでした。',
  driverDisabled: 'ドライバーアカウントを停止しました。',
  driverRemoved: 'ドライバーをフリートから外しました。',
  operationFailed: '操作を完了できませんでした。',
  settingSaved: '設定を保存しました。',
  settingSaveFailed: '設定を保存できませんでした。',
  exitApproved: '退出を承認しました。',
  exitApprovalFailed: '退出申請を処理できませんでした。',
  exitRequests: '退出申請',
  exitRequestsHint: '承認後、ドライバーは別のフリートに参加できます。',
  driver: 'ドライバー',
  pending: '審査待ち',
  allowExit: '退出を承認',
  editDriver: 'ドライバー編集',
  cancel: 'キャンセル',
  driverName: 'ドライバー名',
  initialPassword: '初期パスワード（6文字以上）',
  saving: '保存中…',
  saveChanges: '変更を保存',
  createDriver: 'ドライバーアカウント作成',
  fleetOwner: 'フリート責任者',
  available: '受注可能',
  dispatchable: '配車可能',
  expired: '書類期限切れ',
  disabled: '停止中',
  editProfile: '情報を編集',
  resetPassword: 'パスワード再設定',
  disableAccount: 'アカウント停止',
  removeFromFleet: 'フリートから外す',
  addVehicle: '車両追加',
  vehicleHint: '車両は個別に保存し、予約ごとにドライバー選択後に指定します。',
  vehicleType: '車種',
  plateNumber: 'ナンバープレート',
  platePlaceholder: '例：品川 300 あ 12-34',
  saveVehicle: '車両を保存',
  noVehicleType: '車種未入力',
  noPlate: 'ナンバー未入力',
  delete: '削除',
  noVehicles: '保存済み車両はありません',
  noNotifications: 'フリート通知はありません',
  notification: 'フリート通知',
  permanentFleetCode: '固定フリートコード',
  fleetCodeHint: '新規作成され有効なドライバーはすぐに配車できます。停止中または書類期限切れの場合は自動的に配車対象外になります。',
  showPrice: 'ドライバーに配車価格を表示',
  showPriceHint: '有効にすると、所属ドライバーが予約でフリート精算額を確認できます。',
  reviewDocuments: 'フリート審査資料',
  reviewDocumentsHint: '会社登記簿謄本と運送許可証は本部審査用に保存されています。',
  driversTab: 'ドライバー',
  vehiclesTab: '車両',
  notificationsTab: '通知',
  settingsTab: '設定',
  sectionsLabel: 'フリート管理メニュー',
  passwordResetLabel: 'ドライバーパスワード再設定',
  newPassword: '新しいパスワード（6文字以上）',
  resetHint: 'ドライバーは次回ログイン時にこのパスワードを使用します。',
  confirmReset: '再設定する',
  allowExitTitle: (name) => `${name || 'このドライバー'} の退出を承認しますか？`,
  allowExitHint: '承認後、現在のフリート所属が解除され、別のフリートへ参加できます。未完了の予約がある場合は操作できません。',
  confirmAction: '操作確認',
  removeTitle: (name) => `${name} をフリートから外す`,
  disableTitle: (name) => `${name} を停止する`,
  removeHint: '未完了の予約がない場合のみフリートから外せます。その後は別のフリートへ参加できます。',
  disableHint: '未完了の予約がないか先に確認します。',
  confirmRemove: '外す',
  confirmDisable: '停止する',
};

const zhTw = {
  ...zhCn,
  loading: '正在開啟車隊帳號…',
  application: '車隊申請',
  logout: '登出',
  fleetAccount: '車隊帳號',
  pendingReview: '等待總部審核',
  pendingHint: '審核前可補充車隊資料。通過後，車隊主可使用完整司機端，並在「我的」頁面管理車隊。',
  saveFailed: '資料儲存失敗',
  fleetName: '車隊名稱',
  manager: '負責人',
  email: '電子郵件',
  address: '地址',
  businessRegistration: '公司登記證明',
  transportPermit: '運輸許可',
  saveApplication: '儲存申請資料',
  applicationSaved: '申請資料已儲存。',
  backToDriver: '返回司機入口',
  fleetLogin: '車隊登入',
  fleetLoginHint: '登入後直接使用完整司機端；車隊功能會顯示在「我的」頁面。',
  phone: '手機號碼',
  password: '密碼',
  signingIn: '登入中…',
  enterDriver: '進入司機端',
  loginFailed: '登入失敗，請重試。',
  management: '車隊管理',
  syncing: '同步中',
  refresh: '更新',
  managementHint: '在這裡管理車隊司機與車輛；訂單派單仍在「我的訂單」完成。',
  addDriver: '新增司機',
  fleetDrivers: '車隊司機',
  fleetVehicles: '車隊車輛',
  loadingData: '正在同步車隊資料…',
  loadFailed: '無法載入車隊資料',
  driverUpdated: '司機資料已更新',
  driverCreated: '司機帳號已建立',
  driverSaveFailed: '無法儲存司機資料',
  vehicleSaved: '車輛已儲存',
  vehicleSaveFailed: '無法儲存車輛資料',
  deleteVehicleConfirm: (plate) => `刪除車輛 ${plate || ''}？歷史訂單會保留當時的車輛資訊。`,
  vehicleDeleted: '車輛已刪除',
  vehicleDeleteFailed: '無法刪除車輛',
  passwordReset: '密碼已重設',
  passwordResetFailed: '無法重設密碼',
  driverDisabled: '司機帳號已停用',
  driverRemoved: '司機已移出車隊',
  operationFailed: '操作失敗',
  settingSaved: '設定已儲存',
  settingSaveFailed: '無法儲存設定',
  exitApproved: '已允許退出',
  exitApprovalFailed: '無法處理退出申請',
  exitRequests: '退出申請',
  exitRequestsHint: '審核通過後，司機可加入其他車隊。',
  driver: '司機',
  pending: '待審核',
  allowExit: '允許退出',
  editDriver: '編輯司機',
  cancel: '取消',
  driverName: '司機姓名',
  initialPassword: '初始密碼（至少6位）',
  saving: '儲存中…',
  saveChanges: '儲存修改',
  createDriver: '建立司機帳號',
  fleetOwner: '車隊主',
  available: '可接單',
  dispatchable: '可派單',
  expired: '證件過期',
  disabled: '已停用',
  editProfile: '編輯資料',
  resetPassword: '重設密碼',
  disableAccount: '停用帳號',
  removeFromFleet: '移出車隊',
  addVehicle: '新增車輛',
  vehicleHint: '車輛獨立儲存，指派訂單時再選擇司機和車輛。',
  vehicleType: '車型',
  plateNumber: '車牌號碼',
  platePlaceholder: '例如：品川 300 あ 12-34',
  saveVehicle: '儲存車輛',
  noVehicleType: '未填寫車型',
  noPlate: '未填寫車牌',
  delete: '刪除',
  noVehicles: '暫無已儲存車輛',
  noNotifications: '暫無車隊通知',
  notification: '車隊通知',
  permanentFleetCode: '永久車隊碼',
  fleetCodeHint: '新增且啟用的司機可立即接收車隊派單；停用或證件過期時會自動停止派單。',
  showPrice: '在司機端顯示派單價格',
  showPriceHint: '開啟後，車隊司機可在訂單中看到車隊結算價。',
  reviewDocuments: '車隊審核資料',
  reviewDocumentsHint: '公司登記證明和運輸許可已由總部儲存審核。',
  driversTab: '司機',
  vehiclesTab: '車輛',
  notificationsTab: '通知',
  settingsTab: '設定',
  sectionsLabel: '車隊管理分區',
  passwordResetLabel: '重設司機密碼',
  newPassword: '新密碼（至少6位）',
  resetHint: '司機下次登入時需要使用此密碼。',
  confirmReset: '確認重設',
  allowExitTitle: (name) => `允許 ${name || '該司機'} 退出？`,
  allowExitHint: '確認後，該司機會解除目前車隊歸屬，並可加入其他車隊。未完成訂單會阻止此操作。',
  confirmAction: '確認操作',
  removeTitle: (name) => `移出 ${name}`,
  disableTitle: (name) => `停用 ${name}`,
  removeHint: '該司機必須沒有未完成訂單，移出後可加入其他車隊。',
  disableHint: '系統會先檢查該司機是否有未完成訂單。',
  confirmRemove: '確認移出',
  confirmDisable: '確認停用',
};

export function getFleetPortalText(language = getDriverLanguage()) {
  const normalized = normalizeDriverLanguage(language);
  if (normalized === 'en') return en;
  if (normalized === 'ja') return ja;
  if (normalized === 'zh_tw') return zhTw;
  return zhCn;
}

export const fleetText = { zh_cn: zhCn, zh_tw: zhTw, ja, en };

export function validateFleetTextCatalogs() {
  const expected = Object.keys(en).sort().join("|");
  Object.entries(fleetText).forEach(([language, catalog]) => {
    if (Object.keys(catalog).sort().join("|") !== expected) {
      throw new Error(`fleet_translation_keys_mismatch:${language}`);
    }
  });
  return true;
}
